module.exports = __webpack_public_path__ + "static/media/slider-mockup.72d7d980.webp";